import { call, put } from 'redux-saga/effects';

import { IUserWebAnalyticsResponse } from 'api/components/User/types';
import api from 'api';

import { getUserWebAnalyticsError, getUserWebAnalyticsSuccess } from '../actions';

export function* getUserWebAnalytics() {
    try {
        const response: IUserWebAnalyticsResponse = yield call(api.user.getUserWebAnalytics);

        yield put(getUserWebAnalyticsSuccess(response));
    } catch (error) {
        yield put(getUserWebAnalyticsError());
    }
}
